<template>
  <div>
    <filter-component 
      :showFilters="true"
      :hideStatus="true"
      :hideMovie="true"
      :hideVendor="true"
      :hideRight="true"
      :hideLanguage="true"
      :hideShowDeleted="true"
      :hideExportButton="true"
      @submitFilter="dateSubmitted"
      @resetFilter="resetDate"
    >
    </filter-component>
    <div v-for="(item, index) in notifications" :key="index + 'notification'">
      <b-card>
        <b-media>
          <template #aside>
            <b-avatar
              class="badge-light-primary"
              size="36"
              :variant="item.type"
            >
              <feather-icon icon="BellIcon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder text-black">
              {{ item.notification_heading }}
            </span>
            <span style="float: right">
              {{ getDate(item.createdAt) }}
            </span>
          </p>
          <span class="notification-text">
            {{ item.notification_text }}
          </span>
        </b-media>
      </b-card>
    </div>
    <div>
      <b-button @click="loadMore"> load more </b-button>
    </div>
    <br />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  BCard,
  BCardText,
  BMedia,
  BAvatar,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import * as MasterServices from "@/apiServices/MastersServices";
import FilterComponent from "../../components/Filters.vue";

export default {
  components: {
    BCard,
    BCardText,
    BMedia,
    BAvatar,
    BLink,
    BFormCheckbox,
    VuePerfectScrollbar,
    BButton,
    FilterComponent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      limit: 10,
      notifications: [],
      filters: {},
    };
  },
  methods: {
    loadMore() {
      this.limit = this.limit + 10;
      this.getAllNotifications();
    },
    async getAllNotifications() {
      try {
        const response = await MasterServices.getAllNotifications({
          limit: this.limit,
          start_date: this.filters.date_range ? this.filters.date_range.split(" to ")[0] : "",
          end_date: this.filters.date_range ? this.filters.date_range.split(" to ")[1] : "",
        });
        if (response.data.status) {
          this.notifications = response.data.data;
          console.log("Notification: ", this.notifications, response.data);
        }
      } catch (err) {
        console.log("Error in getting all notifications  ", err);
      }
    },
    getDate(created_at) {
      if (created_at) {
        let date = new Date(created_at);
        return date.toDateString() + " - " + date.toLocaleTimeString();
      }
    },
    dateSubmitted(date){
      this.filters = date;
      this.getAllNotifications();
    },
    resetDate(){
      this.filters = {};
      this.getAllNotifications();
    }
  },
  beforeMount() {
    this.getAllNotifications();
  },
};
</script>

<style>
.badge-light-primary {
  background-color: #e5d5bc !important;
}
</style>
